
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';



const getAll = async (params = {}) => {

  const query = `
    query MyQuery(
      $establecimiento : ID
      $search          : String
      $tokenDoctor     : String
      $especialidad    : ID
      $page            : Int
      $pageSize        : Int
      $excel           : String
      $pdf             : String
    ) {
      allDoctores(
        establecimiento : $establecimiento
        search          : $search
        tokenDoctor     : $tokenDoctor
        especialidad    : $especialidad
        page            : $page
        pageSize        : $pageSize
        excel           : $excel
        pdf             : $pdf
      ) {
        status
        total
        dataarchivo
        doctor {
          id
          token
          numeroregistrosenescyt
          urlTituloSenescyt
          urlP12FirmaElectronica
          fechainiciodoctor
          urlFirmaSello      
          horarios {
            dia
            horaInicio
            horaFin
            duracionTurno
          }
          especialidad {
            id
            descripcion
            codEsp
          }
          idPersona {
            primerNombre, 
            primerApellido, 
            identificacion,
            fechaNacimiento,
            sexo,
            correo
            detalleusuarioSet {
              usuario {
                username
              }
            }
          }
        }
      }
    }
  `;
  const variables = { 
    ...params
  }

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables } );
    if ( response.status !== 200 ) return null;
    
    const response2 = response.data.data.allDoctores;
    if ( response2.status !== 'success' ) return null;
    
    const data = {
      doctores : response2.doctor,
      total    : response2.total,
      archivo  : response2.dataarchivo
    };

    return data;

  } catch (error) {
    console.error("Error fetching Doctores:", error);
  }
}



const searchDoctoresByTerm = async (
  nombre = '', 
  fields,
  establecimiento = ''
) => {

  const defaultFields = ['primerNombre', 'primerApellido', 'identificacion'];

  const queryFields = (fields && fields.length > 0) 
    ? fields.join(',') 
    : defaultFields.join(',');
  
  const query = `
    query MyQuery(
      $search: String
    ) {
      allDoctores(
        search: $search
      ) {
        status
        total
        doctor {
        urlFirmaSello
          id          
          especialidad {
            id
            descripcion
            codEsp
          }
          idPersona {
            ${queryFields}
          }
        }
      }
    }
  `;
  const variables = { 
    search:nombre, 
    establecimiento
  }

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables } );
    const { data } = response;
    return data.data.allDoctores.doctor;

  } catch (error) {
    console.error("Error fetching Doctores:", error);
  }
}



const searchDoctoresByTermSelect = async (search, establecimiento = '') => {

  const response = await searchDoctoresByTerm(search, null, establecimiento);

  const data = response.map(item => ({
    ...item,
    value: item.id,
    text: `${item.idPersona.primerApellido} ${item.idPersona.primerNombre}`,
    especialidad : item.especialidad.descripcion,
    codEsp: item.especialidad.codEsp,
    urlFirmaSello: item.urlFirmaSello
  }));

  return data;
}


export const doctoresService = {
  getAll,
  searchDoctoresByTerm,
  searchDoctoresByTermSelect
}
